export const dataSamplingValues = ['1', '10', '100'] as const

export type DataSampling = (typeof dataSamplingValues)[number]
